import React, { useEffect, useState } from 'react';
import { HelpCircle, Inbox } from 'lucide-react';

// Globale Tooltips: jedes Element mit data-tipp="…" zeigt beim Hovern/Fokussieren einen Hinweis
export const TippSystem = () => {
  const [t, setT] = useState(null);
  useEffect(() => {
    const zeigen = (e) => {
      const el = e.target.closest?.('[data-tipp],[title]');
      if (!el || el.tagName === 'IFRAME') return;
      if (!el.hasAttribute('data-tipp')) { el.setAttribute('data-tipp', el.getAttribute('title')); el.removeAttribute('title'); }
      if (!el.getAttribute('data-tipp')) return;
      const r = el.getBoundingClientRect();
      const oben = r.top > 70;
      setT({ text: el.getAttribute('data-tipp'), x: Math.min(Math.max(r.left + r.width / 2, 130), window.innerWidth - 130), y: oben ? r.top - 8 : r.bottom + 8, oben });
    };
    const weg = (e) => { if (e.target.closest?.('[data-tipp]')) setT(null); };
    let timer;
    const aus = () => setT(null);
    const tipp = (e) => { if (e.pointerType !== 'mouse') { clearTimeout(timer); timer = setTimeout(aus, 2200); } else aus(); };
    document.addEventListener('mouseover', zeigen);
    document.addEventListener('focusin', zeigen);
    document.addEventListener('mouseout', weg);
    document.addEventListener('focusout', weg);
    window.addEventListener('scroll', aus, true);
    document.addEventListener('pointerdown', tipp, true);
    return () => {
      clearTimeout(timer); document.removeEventListener('pointerdown', tipp, true);
      document.removeEventListener('mouseover', zeigen); document.removeEventListener('focusin', zeigen);
      document.removeEventListener('mouseout', weg); document.removeEventListener('focusout', weg); window.removeEventListener('scroll', aus, true);
    };
  }, []);
  if (!t) return null;
  return (
    <div role="tooltip" data-testid="tipp-box" style={{ left: t.x, top: t.y }}
      className={`fixed z-[90] pointer-events-none -translate-x-1/2 ${t.oben ? '-translate-y-full' : ''} max-w-[240px] px-2.5 py-1.5 rounded-lg bg-[#0F243B] text-white text-[11.5px] leading-snug shadow-xl ring-1 ring-[#e0b56a]/30 motion-safe:animate-[fadeIn_.12s_ease-out]`}>
      {t.text}
    </div>
  );
};

// Kleines „?“ neben Feldern und Knöpfen
export const Tipp = ({ text, testId }) => (
  <span tabIndex={0} role="img" aria-label={text} data-tipp={text} data-testid={testId}
    className="inline-flex items-center justify-center w-4 h-4 ml-1 align-middle rounded-full text-[#7a8a99] hover:text-[#b8893d] focus:text-[#b8893d] focus:outline-none cursor-help transition-colors">
    <HelpCircle className="w-3.5 h-3.5" strokeWidth={2} />
  </span>
);

// Hilfreicher leerer Zustand
export const Leer = ({ icon: Icon = Inbox, titel, text, aktion, testId = 'leer-zustand', kompakt }) => (
  <div className={`flex flex-col items-center justify-center text-center rounded-xl border border-dashed border-slate-300/80 bg-slate-50/60 ${kompakt ? 'py-5 px-3' : 'py-9 px-4'}`} data-testid={testId}>
    <span className="w-10 h-10 rounded-full bg-white ring-1 ring-slate-200 flex items-center justify-center mb-2"><Icon className="w-5 h-5 text-[#b8893d]" strokeWidth={1.75} /></span>
    <p className="text-sm font-semibold text-[#1B3A5C]">{titel}</p>
    {text && <p className="text-xs text-slate-500 max-w-sm mt-1 leading-relaxed">{text}</p>}
    {aktion && <div className="mt-3">{aktion}</div>}
  </div>
);
